import { render, staticRenderFns } from "./ownerInfo.vue?vue&type=template&id=0ac38da0&scoped=true&"
import script from "./ownerInfo.vue?vue&type=script&lang=js&"
export * from "./ownerInfo.vue?vue&type=script&lang=js&"
import style0 from "./ownerInfo.vue?vue&type=style&index=0&id=0ac38da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac38da0",
  null
  
)

export default component.exports